import React, { Fragment } from 'react';
import MuiToolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

import { SaveButton } from 'react-admin';
import AcceptButton from './AcceptButton';
import AddCommentButton from './AddCommentButton';

const useStyles = makeStyles({
    root: {
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const IssueEditToolbar = ({
    handleSubmitWithRedirect,
    invalid,
    record,    
    saving,
    permissions
}) => {
    const classes = useStyles();

    return (
        <MuiToolbar className={classes.root}>
            {
                <Fragment>
                    {
                        record.status === 'new' ?
                            <SaveButton
                                handleSubmitWithRedirect={handleSubmitWithRedirect}
                                invalid={invalid}
                                saving={saving}
                                redirect="list"
                                submitOnEnter={true}
                                label='resources.issues.action.comment'
                            /> :
                        record.status === 'in_progress' ? 
                            <>
                                <AddCommentButton record={record} resource={'comments'} />
                            </> :
                            <></>
                    }
                    {
                        permissions.issueManager ? 
                            <AcceptButton record={record} action={'close'} resource={'issues'} permissions={permissions} />
                        : <></>
                    }
                </Fragment>              
            }            
        </MuiToolbar>
    );

};

export default IssueEditToolbar;
